var render, staticRenderFns
import script from "./paperDishMixin.vue?vue&type=script&lang=js"
export * from "./paperDishMixin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de9872d6",
  null
  
)

export default component.exports